export enum Role {
  ROLE_ELEARNING_ADMIN = "auth_roles_elearning_admin",
  ROLE_ELEARNING_USER = "auth_roles_elearning_user",
}

export type RoleKey = keyof typeof Role;

export const ROLE_KEYS = new Map(Object.entries(Role).map(([value, key]) => [key, value])) as Map<Role, RoleKey>;
